export default __webpack_public_path__ + "static/media/daniel.22e725bf.jpg";